import React, { Fragment, useContext, useEffect } from 'react'
import InfoContext from '../../context/info/infoContext'
import Intro from '../Home/Intro'
import Preloaders from '../Preloaders/Preloaders'
import ProgressBars from './ProgressBars'
import Navbar from '../Navbar'
import SkillItem from '../Home/SkillItem'
import Footer from '../Footer'

const About = () => {

    useEffect(() => {
        let mounted = true;

        if(mounted){
            getAllProgressBars();
        }

        return () => {
            mounted = false;
        }

        // eslint-disable-next-line
    },[])

    const infoContext = useContext(InfoContext);

    const { loading, skills, intro, progressBars, getAllProgressBars } = infoContext;

    if(loading){
        return <Preloaders />
    }

    return (
    <Fragment>
    <header id="header-about">
        <Navbar />
    </header>

    <section className="py-3 text-center" id="about-a">
        <div className="container">
            <h1 className="l-heading">About Me</h1>

            <div className="bottom-line"></div>

            <div className="about-info">
                <div className="about-bio py-2">
                    <p className="lead">Full-Stack JavaScript Developer</p>
                    <div className="container">
                    <Intro intro={intro}/>
                    </div>
                </div>
        </div>
        </div>
        </section>

        <section id="about-b" className="py-2">
        <div className="container">
            <h1 className="l-heading text-center">Technical Skills</h1>
            <div className="bottom-line"></div>
            { progressBars && progressBars.map(progress => <ProgressBars progress={progress} key={progress._id}/>) }
        </div>
    </section>

    <section id="about-c" className="text-center py-3">
        <div className="stacks">
        { skills && skills.map((skill, index) => <SkillItem skill={skill} index={index} key={skill._id}/>) }
        </div>
    </section>
    <Footer />
        </Fragment>
    )
}

export default About
